<template>
  <el-container>
    <div class="menu-list" :class="{ active: isActive }">
      <div class="title-info">
        <div>
          <img class="logo" id="logo" src="~@/assets/logo.gif" alt="PLA" />
        </div>
      </div>
      <el-menu :default-active="currentActiveMenu">
        <el-menu-item
          :index="menu.title"
          v-for="(menu, index) in menus"
          :key="index"
          @click="onRoute(menu)"
          v-show="checkRole(menu)"
        >
          <span slot="title">{{ menu.title }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="title-info top-banner">
      <div>
        <img class="logo" id="logo" src="~@/assets/logo.gif" alt="PLA" />
      </div>
    </div>
    <div id="toggle" @click="select()">
      <div class="span" id="top" :class="{ active: isActive }"></div>
      <div class="span" id="middle" :class="{ active: isActive }"></div>
      <div class="span" id="bottom" :class="{ active: isActive }"></div>
    </div>
    <el-main id="main" :class="{ active: isActive, full: isLogin}">
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
import { mapActions } from 'vuex'
import { Loading } from 'element-ui'

export default {
  name: 'dashboard',

  data() {
    return {
      isCollapsed: true,
      isAdmin: false,
      isLogin: window.sessionStorage.getItem('iroha-wallet:username'),
      isActive: false,
      menus: [
        {
          title: 'Dashboard',
          route: 'summary-page',
          needLogin: true,
          needAdmin: false,
          needLogout: false
        },
        {
          title: 'Users',
          route: 'users-page',
          needLogin: true,
          needAdmin: true,
          needLogout: false
        },
        {
          title: 'User Review',
          route: 'user-review-page',
          needLogin: true,
          needAdmin: true,
          needLogout: false
        },
        {
          title: 'Wallet',
          route: 'wallets-page',
          needLogin: true,
          needAdmin: false,
          needLogout: false
        },
        {
          title: 'Block Scan',
          route: 'block-scan-page',
          needLogin: false,
          needAdmin: false,
          needLogout: false
        },
        {
          title: 'Logout',
          route: '',
          needLogin: true,
          needAdmin: false,
          needLogout: false
        },
        {
          title: 'Login',
          route: 'login',
          needLogin: false,
          needAdmin: false,
          needLogout: true
        }
      ]
    }
  },

  created() {
    this.isAdmin =
      window.sessionStorage.getItem('iroha-wallet:username') === 'admin@planet-world.io'
    this.getAccountQuorum()
  },

  computed: {
    currentActiveMenu() {
      return this.$route.meta.title
    }
  },

  methods: {
    select: function() {
      this.isActive = !this.isActive
    },
    ...mapActions(['logout', 'getAccountQuorum']),
    onLogout() {
      this.$confirm('Are you sure to log out of your account?', 'Log Out', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        Loading.service({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.logout().then(() => {
          setTimeout(() => {
            // fullLoading.close()
            window.location.reload()
          }, 500)
        })
      })
    },
    onLogin() {
      this.$router.push('/login')
    },
    onRoute(menu) {
      this.isActive = false
      if (menu.title === 'Logout') {
        this.onLogout()
        return
      }
      if (menu.title === 'Login') {
        this.onLogin()
        return
      }
      if (this.$route.name === menu.route) return
      this.$router.push({ name: menu.route })
    },
    checkRole(menu) {
      return (
        ((menu.needLogin && this.isLogin) || !menu.needLogin) &&
        ((menu.needAdmin && this.isAdmin) || !menu.needAdmin) &&
        ((menu.needLogout && !this.isLogin) || !menu.needLogout)
      )
    }
  }
}
</script>

<style scoped>
  #toggle {
    position: fixed;
    right: 20px;
    top: 14px;
    z-index: 999;
    width: 40px;
    height: 40px;
    cursor: pointer;
    float: right;
    transition: all .3s ease-out;
    visibility: hidden;
    opacity: 0;
  }

  #toggle .span {
    border-radius: 10px;
    background: #eee;
    transition: all 0.3s ease-out;
    backface-visibility: hidden;
  }

  #top.span.active {
    transform: rotate(45deg) translateX(3px) translateY(5px);
  }

  #middle.span.active {
    opacity: 0;
  }

  #bottom.span.active {
    transform: rotate(-45deg) translateX(8px) translateY(-10px);
  }

  #main {
    padding: 0;
  }

  .title-info {
    display: flex;
    justify-content: center;
    font-weight: 600;
    padding: 1rem 0;
    border-bottom: 1px solid #e8e8e8;
    background: #333;
  }

  .title-info .logo {
    width: 240px;
  }

  .menu-list {
    width: 270px;
  }

  .menu-list >>> .el-menu {
    border-right: 0px;
  }

  .menu-list >>> .el-menu-item.is-active {
    background: #f39800;
    color: rgb(255, 255, 255, 1);
    font-weight: 500;
  }

  .menu-item {
    color: #00111f;
    display: block;
    padding: 1rem 0.5rem 1rem 1.5rem;
  }

  .menu-item_text svg {
    margin-right: 0.5rem;
    width: 1rem;
  }

  .router-link-active > .menu-item_text {
    color: rgb(255, 255, 255, 1);
  }

  .menu-item.router-link-active {
    background: #e43e33;
    color: white;
    font-weight: 500;
    pointer-events: none;
  }

  a.menu-item:hover span {
    opacity: 1;
    color: #000000;
  }

  .top-banner {
    display: none;
    z-index: 999;
    position: fixed;
    top: 0;
    width: 100%;
  }

  @media only screen and (max-width: 768px) {
    .el-container {
      display: block;
      position: relative;
    }

    .top-banner {
      display: flex;
    }
  
    .menu-list {
      display: none;
      width: 100%;
      border-bottom: solid 2px #ccc;
    }

    #toggle {
      visibility: visible;
      opacity: 1;
      position: fixed;
      margin-top: 6px;
    }

    #toggle .span {
      height: 4px;
      margin: 5px 0;
      transition: all .3s ease-out;
      backface-visibility: visible;
      visibility: visible;
      opacity: 1;
    }

    .menu-list .el-menu-item {
      display: none;
    }

    .menu-list.active {
      display: block;
      visibility: visible;
      opacity: 0.98;
      transition: all .5s ease-out;
      position: fixed;
      width: 100%;
      z-index: 999;
    }

    .menu-list.active .el-menu-item {
      text-align: center;
      float: none;
      display: block;
      height: 100%;
      width: 100%;
      border-top: 1px solid #EAEAEB;
      font-size: 18px;
    }

    .menu-list.active .title-info {
      display: none;
    }

    #main {
      margin: 92px 0;
    }

    #main.active {
      padding-top: 150px;
    }

    #main.active.full {
      padding-top: 360px;
    }
  }
</style>